
import React from 'react';
import PageLayout from './src/components/PageLayout';
import { ConfigLayout } from './src/util/data/config-layout';
import MultiBrandPageLayout from './src/components/multi-brand-components/MultiBrandPageLayout';

export function wrapPageElement({ element, props }) {
  const { pathname } = props.location;
  const isEndWithSlash =  pathname.endsWith("/") ? pathname : `${pathname}/`;

   const matchedLayout = ConfigLayout.find(each => isEndWithSlash === each.path && each.layoutComp === "PageLayout");

    if(matchedLayout){
      return <PageLayout {...props}>{element}</PageLayout>;
    }
    
    return <MultiBrandPageLayout {...props}>{element}</MultiBrandPageLayout>
}